import React from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import { push } from "react-router-redux";
import { connect } from "react-redux";
import {
  DataTable,
  PartNumber,
  SearchPropTypes
} from "MODULES/shared/components";
import { shortDate } from "LIB/formatters/date";
import translateProps from "MODULES/shared/decorators/translateProps";
import MultiLocationFeature from "MODULES/shared/components/MultiLocationFeature/MultiLocationFeature";
import { CONDITIONS } from "MODULES/Shipping/constants";
import { truncate } from "LIB/formatters/text";
import LocationFlag from "../../../shared/components/LocationFlag";

function BasicRow({ record, handleClick }) {
  return (
    <tr className="clickable" onClick={handleClick}>
      <td>{record.code}</td>
      <td>{shortDate(record.created_at)}</td>
      <MultiLocationFeature>
        <td className="text-center">
          <LocationFlag location={record.store_location_id} />
        </td>
      </MultiLocationFeature>
      <td>{_.get(record, "company.name")}</td>
      <td>
        <PartNumber part={record.part} />
      </td>
      <td>{record.serial_number}</td>
      <td>
        {record.condition_received &&
          CONDITIONS[record.condition_received].label}
      </td>
      <td>{record.location}</td>
      <td className="text-center">{record.quantity}</td>

      <td>{truncate(record.incoming_awb_number, 14)}</td>
      <td>{truncate(record.outgoing_awb_number, 14)}</td>
    </tr>
  );
}

BasicRow.propTypes = {
  record: PropTypes.shape({}),
  statuses: PropTypes.shape({}),
  handleClick: PropTypes.func
};

const withProps = translateProps(({ record, pushHistory }) => ({
  handleClick: () => pushHistory(`/rejected-cores/${record.uuid}`)
}));

const Row = connect(undefined, { pushHistory: push })(withProps(BasicRow));

export function Table({ isLoading, pageActions, results }) {
  return (
    <DataTable loading={isLoading} refresh={pageActions.expire}>
      <DataTable.Head>
        <th>RC #</th>
        <th>REC Date</th>
        <MultiLocationFeature>
          <th className="text-center">Store Loc</th>
        </MultiLocationFeature>
        <th>Company</th>
        <th>Part #</th>
        <th>Serial #</th>
        <th>Cond Rec</th>
        <th>Location</th>
        <th className="text-center">QTY Rec</th>
        <th>Incoming Awb #</th>
        <th>Outgoing Awb #</th>
      </DataTable.Head>
      <DataTable.Body>
        {results.map(record => <Row key={record.id} record={record} />)}
      </DataTable.Body>
    </DataTable>
  );
}

Table.propTypes = {
  ...SearchPropTypes
};

export default connect(undefined, { pushHistory: push })(Table);



// WEBPACK FOOTER //
// ./app/modules/RejectedCores/components/Search/Table.jsx